<div class="grid">
    <div class="component grid-item">
        <app-history-bookmarks></app-history-bookmarks>
    </div>
</div>
